export const ADD_ROOM = 'addRoom';
export const REMOVE_ROOM = 'removeRoom';
export const SET_EDIT_MODE = 'setEditMode';
export const UPDATE_ROOM = 'updateRoom';
export const MAX_ROOM_COUNT = 5;
export const CHILD_AGE_PLACEHOLDER = 'Age';
export const BED_REQUIRED_ENUM = {
  Yes: 'Yes',
  No: 'No',
};
export const PAX_CONFIG = {
  maxChildAge: 11,
  minChildAge: 2,
  childWithBed: false,
};
